<template>
  <div class="button-field-editor">
    <div class="form-group">
      <label for="text-fr">Texte du Bouton (FR):</label>
      <input
        id="text-fr"
        type="text"
        :value="localFieldData.text_fr"
        @input="updateField('text_fr', $event.target.value)"
        placeholder="Entrez le texte en français"
        class="form-control"
      />
    </div>

    <div class="form-group">
      <label for="text-en">Texte du Bouton (EN):</label>
      <input
        id="text-en"
        type="text"
        :value="localFieldData.text_en"
        @input="updateField('text_en', $event.target.value)"
        placeholder="Enter button text in English"
        class="form-control"
      />
    </div>

    <div class="form-group">
      <label for="link">Lien de Redirection:</label>
      <input
        id="link"
        type="text"
        :value="localFieldData.to"
        @input="updateField('to', $event.target.value)"
        placeholder="Entrez l'URL de redirection"
        class="form-control"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ButtonFieldEditor",
  props: {
    fieldData: {
      type: Object,
      required: true,
    },
    fieldKey: String,
  },
  data() {
    return {
      localFieldData: { ...this.fieldData }, // Local copy to avoid direct mutation of props
    };
  },
  watch: {
    // Sync local data with props when parent updates
    fieldData: {
      handler(newFieldData) {
        this.localFieldData = { ...newFieldData };
      },
      immediate: true,
    },
  },
  methods: {
    updateField(fieldName, value) {
      this.localFieldData[fieldName] = value; // Update local copy
      // Emit update event to parent
      this.$emit("update-field", {
        key: this.fieldKey,
        fieldName,
        value,
      });
    },
  },
};
</script>

<style scoped>
.button-field-editor {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

label {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

.form-control {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  width: 100%;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.form-control:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 4px rgba(0, 123, 255, 0.5);
}
</style>
